import {
  FETCH_DELIVERY_PERSON_LIST,
  RESET_DELIVERY_PERSON_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  selectList: [],
  others: {},
};

const deliveryPersonListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DELIVERY_PERSON_LIST:
      return {
        list: action.payload,
        others: action.others,
        selectList: action.payload.filter((item) => item.is_active),
      };
    case RESET_DELIVERY_PERSON_LIST:
      return initialState;
    default:
      return state;
  }
};

export default deliveryPersonListReducer;
